import { hzToMhz } from '../lib/frequency.js';
import type { FrequencyChannel } from '../types/frequency-channel.js';
import type { FrequencyRange } from '../types/frequency-range.js';

export type DeviceFrequencyRangeForm = {
  startFrequency: number;
  endFrequency: number;
  step: number;
  isDigital: boolean;
  enabled: boolean;
};

export const mapChannelsFromApi = (input: unknown): FrequencyChannel[] => {
  if (!Array.isArray(input)) return [];

  return input.map((raw) => {
    const item = raw as Partial<FrequencyChannel> & Record<string, unknown>;

    return {
      band: String(item.band ?? ''),
      group: String(item.group ?? ''),
      channel: Number(item.channel ?? 0) || 0,
      freq: hzToMhz(Number(item.freq ?? 10_000_000)),
      isDigital: Boolean(item.isDigital),
      enabled: Boolean(item.enabled),
    };
  });
};

export const mapRangesFromApi = (input: unknown): DeviceFrequencyRangeForm[] => {
  if (!Array.isArray(input)) return [];
  return input.map((raw) => {
    const item = raw as Partial<FrequencyRange> & Record<string, unknown>;
    const startHz = Number(item.startFrequency ?? 0) || 0;
    const endHz = Number(item.endFrequency ?? 0) || 0;
    const rawStep = Number(item.step ?? 10_000_000);
    const stepHz = Number.isFinite(rawStep) && rawStep > 0 ? rawStep : 10_000_000;

    return {
      startFrequency: hzToMhz(startHz),
      endFrequency: hzToMhz(endHz),
      step: hzToMhz(stepHz),
      isDigital: Boolean(item.isDigital),
      enabled: Boolean(item.enabled),
    };
  });
};
